import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=2a0c0c50&scoped=true&"
import script from "./InvoiceList.vue?vue&type=script&lang=ts&"
export * from "./InvoiceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0c0c50",
  null
  
)

export default component.exports